// import { inject } from '@angular/core';
import { Route } from '@angular/router';
import {
  NbAuthComponent,
  NbLogoutComponent,
  NbRequestPasswordComponent,
  NbResetPasswordComponent,
} from '@nebular/auth';
import { canAuthenticated, canUnAuthenticated } from '@res/ngg-core';
import { LoginComponent } from './auth/login.component';

export const appRoutes: Route[] = [
  {
    path: '',
    canActivate: [canAuthenticated],
    loadChildren: () => import('./pages/pages.routes').then((m) => m.routes),
  },
  {
    path: 'auth',
    component: NbAuthComponent,
    providers: [],
    // No guard on the parent: Angular runs parent guards for child activation, so a
    // canUnAuthenticated here bounced signed-in users away from `logout` and left the app with no
    // way to end a session. Each child that must stay anonymous carries the guard itself.
    children: [
      {
        path: '',
        component: LoginComponent,
        canActivate: [canUnAuthenticated],
      },
      {
        path: 'login',
        component: LoginComponent,
        canActivate: [canUnAuthenticated],
      },
      {
        // Deliberately unguarded: this is the only sign-out affordance, and it is only ever reached
        // by an authenticated user. NbLogoutComponent is inert for anonymous callers.
        path: 'logout',
        component: NbLogoutComponent,
      },
      {
        path: 'request-password',
        component: NbRequestPasswordComponent,
        canActivate: [canUnAuthenticated],
      },
      {
        path: 'reset-password',
        component: NbResetPasswordComponent,
        canActivate: [canUnAuthenticated],
      },
    ],
  },
  // No `auth/register` route. The CRM is internal, and with the Firebase password strategy
  // NbRegisterComponent would call createUserWithEmailAndPassword against the live project, letting
  // any visitor of the public Cloudflare Pages URL mint themselves an account. Partners are
  // provisioned out of band (Firebase console / tools/custom-claim-setter.js).
  // { path: '', redirectTo: 'partners', pathMatch: 'full' },
  { path: '**', redirectTo: '' /*, pathMatch: 'full' */ },
];
